import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  hide: {
    display: "none",
  },
  noStoriesFoundContainer: {
    textAlign: "center",
    marginTop: "32px",
    "& h1": {
      fontWeight: foundations.typography.fontWeight.medium,
      fontSize: "18px",
      marginBottom: "4px",
    },
    "& h2": {
      marginBottom: "24px",
      fontWeight: "unset",
    },
  },
  filterResultButtons: {
    display: "flex",
    justifyContent: "center",
  },
  allStoryButton: {
    marginLeft: "12px",
  },
});
